import { render, staticRenderFns } from "./iconHigiene.vue?vue&type=template&id=c5960148&scoped=true&"
import script from "./iconHigiene.vue?vue&type=script&lang=js&"
export * from "./iconHigiene.vue?vue&type=script&lang=js&"
import style0 from "./iconHigiene.vue?vue&type=style&index=0&id=c5960148&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5960148",
  null
  
)

export default component.exports